export default __webpack_public_path__ + "static/media/cs_online.4c9a75b6.png";